import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {setJwtToken} from "../redux/auth";
import useApi from "../api/useApi";
import {useAppDispatch} from "../hooks";

export const useLoginCommand = (): ICommand => {
  const messages = useMessageLogic()
  const api = useApi()
  const dispatch = useAppDispatch()

  return {
    help(): string {
      return '- login [USERNAME]/[PASSWORD]\t\t:: log in with username and password';
    },

    async process(msg: string): Promise<void> {
      const creds = msg.substring('login'.length).trim();
      const [username, password] = creds.split('/');

      if (!username || !password) {
        messages.addErrorMessage("format: login username/password")
      } else {
        try {
          const response = await api.users.login(username, password);
          dispatch(setJwtToken(response.jwtToken))
          messages.addSuccessMessage('successfully logged in')
        } catch (e: any) {
          messages.addErrorMessage("failed to login: " + e)
        }
      }
    },

    matches(msg: string): boolean {
      return msg.toLowerCase().trim().startsWith('login')
    }
  };
}